import {ChangeDetectionStrategy, Component, computed, input, InputSignal, output, OutputEmitterRef, Signal} from '@angular/core';
import {Icon} from '../../types/icons/icon.type';
import {ButtonComponent} from '../buttons/button/button.component';
import {TranslationKey} from '../../types/available-translations.type';
import {TranslatePipe} from '@ngx-translate/core';
import {AppButtonTypeEnum} from '../../enums/button/app-button-type.enum';

@Component({
    host: { '[attr.data-qa]': 'this.dataQa()' },
    selector: 'app-action-item',
    templateUrl: './action-item.component.html',
    styleUrls: ['./action-item.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        TranslatePipe,
    ]
})
export class ActionItemComponent {
    public tag: InputSignal<string | undefined> = input.required<string | undefined>();
    public description: InputSignal<TranslationKey> = input.required<TranslationKey>();
    public svgIcon: InputSignal<Icon | undefined> = input<Icon>();
    public hideInSmallMenu: InputSignal<boolean> = input<boolean>(false);
    public smallMenuOrderNumber: InputSignal<number> = input<number>(0);
    public itemClass: InputSignal<string> = input<string>('');
    public clicked: OutputEmitterRef<void> = output<void>();
    protected dataQa: Signal<string>;
    protected readonly AppButtonType = AppButtonTypeEnum.ICON_WITH_TEXT_BUTTON;

    public constructor() {
        this.dataQa = computed(() => this.tag() + '-large');
    }

    public activate(): void {
        this.clicked.emit();
    }
}
